module.exports = __webpack_public_path__ + "img/ico-file.a1271e38.svg";